import { useEffect, useRef, useState } from "react";
import useEbsApiClient from "./useEbsApiClient.js";

const dismissedMessageIdsStorageKey = "cotl.dismissedMessageIds";

export default function useMessages(messageCategory, language = "en") {
  const ebsApiClient = useEbsApiClient();
  const [allMessages, setAllMessages] = useState({});
  const storedDismissedMessageIds = localStorage.getItem(
    dismissedMessageIdsStorageKey
  );
  const [dismissedMessageIds, setDismissedMessageIds] = useState(
    storedDismissedMessageIds ? JSON.parse(storedDismissedMessageIds) : []
  );
  const pollingIntervalRef = useRef(null);

  const fetchMessages = async () => {
    try {
      const messagesResponse = await ebsApiClient.get("/messages");
      setAllMessages(messagesResponse.data);
    } catch (err) {}
  };

  const startPollingForMessages = (intervalDuration) => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }

    pollingIntervalRef.current = setInterval(fetchMessages, intervalDuration);
  };

  useEffect(() => {
    fetchMessages();

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    localStorage.setItem(
      dismissedMessageIdsStorageKey,
      JSON.stringify(dismissedMessageIds)
    );
  }, [dismissedMessageIds]);

  const dismissMessage = (messageId) => {
    setDismissedMessageIds((ids) => [...ids, messageId]);
  };

  return {
    messages: (allMessages[messageCategory] || []).filter(
      (message) => !dismissedMessageIds.includes(message.id)
    ),
    dismissMessage,
    startPollingForMessages,
  };
}
